import { render, staticRenderFns } from "./AcademicLoadColumnsSelector.vue?vue&type=template&id=1f617092&scoped=true"
import script from "./AcademicLoadColumnsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademicLoadColumnsSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AcademicLoadColumnsSelector.vue?vue&type=style&index=0&id=1f617092&prod&scoped=true&lang=css"
import style1 from "./AcademicLoadColumnsSelector.vue?vue&type=style&index=1&id=1f617092&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f617092",
  null
  
)

export default component.exports